
import { CLONE_IDEA_TEMPLATE_ADD_FAILURE, CLONE_IDEA_TEMPLATE_ADD_STARTED, CLONE_IDEA_TEMPLATE_ADD_SUCCESS, CLONE_SCORECARD_TEMPLATE_ADD_FAILURE, CLONE_SCORECARD_TEMPLATE_ADD_STARTED, CLONE_SCORECARD_TEMPLATE_ADD_SUCCESS, GET_IDEA_TEMPLATE_EDIT_ID_FAILURE, GET_IDEA_TEMPLATE_EDIT_ID_STARTED, GET_IDEA_TEMPLATE_EDIT_ID_SUCCESS, GET_IDEA_TEMPLATE_LIST_FAILURE, GET_IDEA_TEMPLATE_LIST_STARTED, GET_IDEA_TEMPLATE_LIST_SUCCESS, GET_SCORECARD_TEMPLATE_EDIT_ID_FAILURE, GET_SCORECARD_TEMPLATE_EDIT_ID_STARTED, GET_SCORECARD_TEMPLATE_EDIT_ID_SUCCESS, GET_SCORECARD_TEMPLATE_LIST_FAILURE, GET_SCORECARD_TEMPLATE_LIST_STARTED, GET_SCORECARD_TEMPLATE_LIST_SUCCESS, POST_IDEA_TEMPLATE_CREATE_FAILURE, POST_IDEA_TEMPLATE_CREATE_STARTED, POST_IDEA_TEMPLATE_CREATE_SUCCESS, POST_SCORECARD_TEMPLATE_CREATE_FAILURE, POST_SCORECARD_TEMPLATE_CREATE_STARTED, POST_SCORECARD_TEMPLATE_CREATE_SUCCESS, PUT_IDEA_TEMPLATE_EDIT_FAILURE, PUT_IDEA_TEMPLATE_EDIT_STARTED, PUT_IDEA_TEMPLATE_EDIT_SUCCESS, PUT_SCORECARD_TEMPLATE_EDIT_FAILURE, PUT_SCORECARD_TEMPLATE_EDIT_STARTED, PUT_SCORECARD_TEMPLATE_EDIT_SUCCESS } from "actions/sync/templates/Constants"


const initialState = {
  createScorecardTemplateLoading: false,
  updateScorecardTemplateLoading: false,
  listScorecardTemplateLoading: false,
  createIdeaTemplateLoading: false,
  updateIdeaTemplateLoading: false,
  listIdeaTemplateLoading: false,
  editIdIdeaTemplateLoading: false,
  editIdScorecardTemplateLoading: false,
  cloneIdeaTemplateIsLoading: false,
  cloneScorecardTemplateIsLoading: false,
  editId_ScorecardTemplate:[],
  editId_IdeaTemplate:[],
  createScorecardTemplate: [],
  editScorecardTemplate:[],
  listScorecardTemplate:[],
  createIdeaTemplate: [],
  editIdeaTemplate:[],
  listIdeaTemplate:[],
  cloneIdeaTemplate:[],
  cloneScorecardTemplate:[],
}


const TemplateReducer = (state = initialState, action) => {
  switch (action.type) {
    case POST_SCORECARD_TEMPLATE_CREATE_STARTED:
      return {
        ...state,
        createScorecardTemplateLoading: true,
      }
    case POST_SCORECARD_TEMPLATE_CREATE_SUCCESS:
      return {
        ...state,
        createScorecardTemplate: action.response,
        createScorecardTemplateLoading: false,
      }
      case POST_SCORECARD_TEMPLATE_CREATE_FAILURE:
        return {
          ...state,
          createScorecardTemplateLoading:false
        }
      
      case GET_SCORECARD_TEMPLATE_LIST_STARTED:
      return {
        ...state,
        listScorecardTemplateLoading: true,
      }
    case GET_SCORECARD_TEMPLATE_LIST_SUCCESS:
      return {
        ...state,
        listScorecardTemplate: action.response,
        listScorecardTemplateLoading: false,
      }
      case GET_SCORECARD_TEMPLATE_LIST_FAILURE:
        return {
          ...state,
          listScorecardTemplateLoading:false
        }
      
    case PUT_SCORECARD_TEMPLATE_EDIT_STARTED:
      return {
        ...state,
        updateScorecardTemplateLoading: true,
      }
    case PUT_SCORECARD_TEMPLATE_EDIT_SUCCESS:
      return {
        ...state,
        editScorecardTemplate: action.response,
        updateScorecardTemplateLoading: false,
      }
    case PUT_SCORECARD_TEMPLATE_EDIT_FAILURE:
      return {
        ...state,
        updateScorecardTemplateLoading: false
      }

      case POST_IDEA_TEMPLATE_CREATE_STARTED:
      return {
        ...state,
        createIdeaTemplateLoading: true,
      }
    case POST_IDEA_TEMPLATE_CREATE_SUCCESS:
      return {
        ...state,
        createIdeaTemplate: action.response,
        createIdeaTemplateLoading: false,
      }
      case POST_IDEA_TEMPLATE_CREATE_FAILURE:
        return {
          ...state,
          createIdeaTemplateLoading:false
        }

      case GET_IDEA_TEMPLATE_LIST_STARTED:
      return {
        ...state,
        listIdeaTemplateLoading: true,
      }
    case GET_IDEA_TEMPLATE_LIST_SUCCESS:
      return {
        ...state,
        listIdeaTemplate: action.response,
        listIdeaTemplateLoading: false,
      }
      case GET_IDEA_TEMPLATE_LIST_FAILURE:
        return {
          ...state,
          listIdeaTemplateLoading:false
        }

    case PUT_IDEA_TEMPLATE_EDIT_STARTED:
      return {
        ...state,
        updateIdeaTemplateLoading: true,
      }
    case PUT_IDEA_TEMPLATE_EDIT_SUCCESS:
      return {
        ...state,
        editIdeaTemplate: action.response,
        updateIdeaTemplateLoading: false,
      }
    case PUT_IDEA_TEMPLATE_EDIT_FAILURE:
      return {
        ...state,
        updateIdeaTemplateLoading: false
      }

    case GET_IDEA_TEMPLATE_EDIT_ID_STARTED:
      return {
        ...state,
        editIdIdeaTemplateLoading: true,
      }
    case GET_IDEA_TEMPLATE_EDIT_ID_SUCCESS:
      return {
        ...state,
        editId_IdeaTemplate: action.response,
        editIdIdeaTemplateLoading: false,
      }
    case GET_IDEA_TEMPLATE_EDIT_ID_FAILURE:
      return {
        ...state,
        editIdIdeaTemplateLoading: false
      }
    case GET_SCORECARD_TEMPLATE_EDIT_ID_STARTED:
      return {
        ...state,
        editIdScorecardTemplateLoading: true,
      }
    case GET_SCORECARD_TEMPLATE_EDIT_ID_SUCCESS:
      return {
        ...state,
        editId_ScorecardTemplate: action.response,
        editIdScorecardTemplateLoading: false,
      }
    case GET_SCORECARD_TEMPLATE_EDIT_ID_FAILURE:
      return {
        ...state,
        editIdScorecardTemplateLoading: false
      }

    case CLONE_IDEA_TEMPLATE_ADD_STARTED:
      return {
        ...state,
        cloneIdeaTemplateIsLoading: true,
      }

    case CLONE_IDEA_TEMPLATE_ADD_SUCCESS:
      return {
        ...state,
        cloneIdeaTemplate: action.response,
        cloneIdeaTemplateIsLoading: false,
      }

    case CLONE_IDEA_TEMPLATE_ADD_FAILURE:
      return {
        ...state,
        cloneIdeaTemplateIsLoading: false
      }

    case CLONE_SCORECARD_TEMPLATE_ADD_STARTED:
      return {
        ...state,
        cloneScorecardTemplateIsLoading: true,
      }

    case CLONE_SCORECARD_TEMPLATE_ADD_SUCCESS:
      return {
        ...state,
        cloneScorecardTemplate: action.response,
        cloneScorecardTemplateIsLoading: false,
      }

    case CLONE_SCORECARD_TEMPLATE_ADD_FAILURE:
      return {
        ...state,
        cloneScorecardTemplateIsLoading: false
      }
      

    default:
      return state
  }
}

export default TemplateReducer
